import React, { useContext, useEffect, useState } from 'react';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import {
	BusFareAddOnContext,
	CurrencyContext,
	CurrentCurrencyContext,
	HealthCareAddOnContext,
	InsuranceAddonContext,
	ValueMealAddonContext,
} from '../UserContext';
import {
	checkIsReschedule,
	deleteSelectedAddOnData,
	getAddOnTicketType,
	getMonetaryUnitText,
	getSelectedAddOnData,
	getToken,
	sessionStorageGetItem,
	sessionStorageSetItem,
	setSelectedAddOnData,
	tokenIsValid,
} from './Function';
import { useSearchParams } from 'react-router-dom';

export const AddOn = ({ page }) => {

	const SERVER_URL = process.env.REACT_APP_SERVER_URL;
	// const SERVER_URL = 'https://expressapi.transitos.io/api/v1';

	const checkReschedule = checkIsReschedule();
	let origin_data = sessionStorageGetItem('Origin_data');
	if (origin_data != null) {
		origin_data = JSON.parse(origin_data);
	}
	// console.log(origin_data)
	let { BusFareAddOn, setBusFareAddOn } = useContext(BusFareAddOnContext);
	const [addOnData, setAddOnData] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [searchParams, setSearchParams] = useSearchParams();

	const { insuranceAddOn, setInsuranceAddOn } = useContext(
		InsuranceAddonContext,
	);

	const { healthCareAddOn, setHealthCareAddOn } = useContext(
		HealthCareAddOnContext,
	);

	const { valueMealAddon, setValueMealAddOn } = useContext(
		ValueMealAddonContext,
	);

	const { currentCurrency, setCurrentCurrency } = useContext(
		CurrentCurrencyContext,
	);

	const { exchangeCurrency, setExchangeCurrency } = useContext(CurrencyContext);

	const monetaryUnit = getMonetaryUnitText(currentCurrency);

	const noOfPax = Number(searchParams.get('passenger') || 1);

	const sessionInsurance = sessionStorageGetItem('insuranceAddOn');
	const sessionHealthCare = sessionStorageGetItem('healthCareAddOn');
	const sessionValueMeal = sessionStorageGetItem('valueMealAddOn');

	const insuranceAddOnData = insuranceAddOn?.fee
		? insuranceAddOn
		: sessionInsurance
			? JSON.parse(sessionInsurance)
			: { plan: 'No Insurance', fee: 0 };

	const healthCareAddOnData = healthCareAddOn?.fee
		? healthCareAddOn
		: sessionHealthCare
			? JSON.parse(sessionHealthCare)
			: { item: '', fee: 0, isReturn: false };

	const valueMealAddOnData = valueMealAddon?.fee
		? valueMealAddon
		: sessionValueMeal
			? JSON.parse(sessionValueMeal)
			: { item: '', fee: 0 };

	sessionStorageSetItem('insuranceAddOn', JSON.stringify(insuranceAddOnData));
	sessionStorageSetItem('healthCareAddOn', JSON.stringify(healthCareAddOnData));
	sessionStorageSetItem('valueMealAddOn', JSON.stringify(valueMealAddOnData));

	let addonSession = sessionStorageGetItem('addOnSession');
	// console.log(getToken())
	useEffect(() => {
		// console.log(addonSession)
		if (addonSession !== null) {
			addonSession = JSON.parse(addonSession);
		}

		const getAddOnData = async () => {
			try {
				const addOn_response = await fetch(
					`${SERVER_URL}/order/addon/${addonSession}`,
					{
						headers: {
							Authorization: getToken(),
						},
					},
				);
				if (!addOn_response.ok) {
					throw new Error(
						`This is an HTTP error: The status is ${addOn_response.status}`,
					);
				} else {
					let addOn_Data = await addOn_response.json();
					setAddOnData(addOn_Data);
					if (
						addOn_Data != 'null' &&
						addOn_Data != null &&
						addOn_Data.length != 0
					) {
						setSelectedAddOnData(addOn_Data);
					}
					setError(null);
					// console.log(addOn_Data)
					sessionStorage.removeItem('addOnSession');
					window.location.reload();
				}
			} catch (err) {
				setError(err.message);
				setAddOnData(null);
				// console.log("Error")
				// console.log(err.message)
			} finally {
				setLoading(false);
			}
		};
		tokenIsValid();

		if (addonSession !== null) {
			getAddOnData();
		}
	}, [getToken()]);

	useEffect(() => {
		if (loading === false) {
			sessionStorage.removeItem('addOnSession');
		}
	}, []);
	// console.log(addOnData)
	// console.log(getSelectedAddOnData())
	// console.log((sessionStorageGetItem("selected_addon_data")))
	const selectedAddOnData = getSelectedAddOnData();
	// console.log(selectedAddOnData);
	// console.log('add on: '+BusFareAddOn);

	function removeAddOn(index, sessionID, labelID) {
		tokenIsValid();
		var addOn_Data = getSelectedAddOnData();
		// console.log(addOn_Data)
		// console.log('delete: '+index)
		deleteSelectedAddOnData(index);
		sessionStorage.removeItem('addOnSession');
		//call api to chg status
		const update_addOn_api_url = `${SERVER_URL}/order/update/addon/status`;

		const update_addOn_requestOptions = {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: getToken(),
			},
			body: JSON.stringify({
				SessionID: sessionID,
				LabelID: labelID,
				Status: 'N',
			}),
		};
		// console.log(update_addOn_requestOptions)
		const updateStatus = async () => {
			try {
				const update_addOn_response = await fetch(
					update_addOn_api_url,
					update_addOn_requestOptions,
				);
				if (!update_addOn_response.ok) {
					throw new Error(
						`This is an HTTP error: The status is ${update_addOn_response.status}`,
					);
				} else {
					setError(null);
					sessionStorage.removeItem('addOnSession');
					alert('Item Removed');
					window.location.reload();
				}
			} catch (err) {
				// console.log(err.message);
				alert(err.message);
				setError(err.message);
			}
		};
		updateStatus();
	}

	if (
		(selectedAddOnData !== null && selectedAddOnData.length !== 0) ||
		insuranceAddOnData.plan !== 'No Insurance' ||
		healthCareAddOnData.fee > 0 ||
		valueMealAddOnData.fee > 0
	) {
		return (
			<>
				<div className='bus_fare_add_on'>
					<Row>
						<Col lg={12}>
							<div className='add-On-container'>
								<div className='text-in-line'>
									<h2>Add On</h2>
								</div>
								<div className='arrow-add-on'></div>
							</div>
						</Col>
					</Row>
					{selectedAddOnData !== null && selectedAddOnData.length > 0
						? selectedAddOnData.map(
							(
								{
									id,
									name,
									totalqty,
									traveldate,
									totalamt,
									details,
									sessionid,
									totalamtinsgd,
									totalamtinmyr,
								},
								index,
							) => (
								<div className='bus-fare-add-on'>
									<Row>
										<table className='mt-4 add-on-table'>
											<tr>
												<td width={'70%'} colSpan={2}>
													<h4>{name}</h4>
												</td>
												<td width={'30%'}>
													<img
														className='cursor_pointer'
														onClick={() => removeAddOn(index, sessionid, id)}
														src='./images/ic_delete_addon.png'
													/>
												</td>
												<td></td>
											</tr>

											{details !== null &&
												details.map(({ id, name, qty, subtotal }, index) => (
													<tr>
														<td width={'50%'}>
															<h6>{getAddOnTicketType(name)}</h6>
														</td>
														<td>
															<h6>x {qty}</h6>
														</td>
														<td>
															<h5>
																{monetaryUnit}{' '}
																{currentCurrency === 'MYR'
																	? totalamtinmyr
																	: totalamtinsgd || 0}
															</h5>
														</td>
													</tr>
												))}
										</table>
									</Row>
								</div>
							),
						)
						: ''}

					<div>
						{insuranceAddOnData.plan !== 'No Insurance' ? (
							<div style={{ margin: '20px 0 0 0' }}>
								<h4
									style={{
										padding: '0 20px',
										fontSize: '14px',
										margin: '10px 0 0',
										fontWeight: 'bold',
									}}
								>
									Travel Protection
								</h4>
								<table width={'100%'}>
									<tr>
										<td>
											<h6>{insuranceAddOnData.plan}</h6>
										</td>
										<td>
											<h5>
												{insuranceAddOn.fee === 0
													? 'Free'
													: (
														insuranceAddOnData.fee /
														(currentCurrency === 'MYR'
															? 1
															: exchangeCurrency.addOnCurrency)
													).toFixed(2)}
												{noOfPax > 1 ? ` (${noOfPax} Passengers)` : ''}
											</h5>
										</td>
									</tr>
								</table>
							</div>
						) : (
							''
						)}

						{healthCareAddOnData.fee && healthCareAddOnData.fee > 0 ? (
							<div style={{ margin: '20px 0 0 0' }}>
								<div
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
										margin: '20px 0 0',
									}}
								>
									<h4
										style={{
											padding: '0 20px',
											fontSize: '14px',
											fontWeight: 'bold',
											margin: '0',
										}}
									>
										Health Care
									</h4>
									{healthCareAddOnData.canDelete !== false ? (
										<div
											className='remove-button'
											onClick={() => {
												setHealthCareAddOn({
													item: '',
													fee: 0,
													isReturn: false,
												});

												sessionStorageSetItem(
													'healthCareAddOn',
													JSON.stringify({}),
												);
											}}
										>
											<img src='./images/ic_delete_addon.png' />
										</div>
									) : (
										''
									)}
								</div>
								<table width={'100%'}>
									<tr>
										<td>
											<h6>{healthCareAddOnData.item}</h6>
										</td>
										<td>
											<h5>
												{healthCareAddOnData.fee === 0
													? 'Free'
													: `${(
														(healthCareAddOnData.isReturn
															? healthCareAddOnData.fee / 2
															: healthCareAddOnData.fee) /
														(currentCurrency === 'MYR'
															? 1
															: exchangeCurrency.addOnCurrency)
													).toFixed(2)} ${healthCareAddOnData.isReturn ? ' x2' : ''
													} ${noOfPax > 1 ? ` (${noOfPax} Passengers)` : ''}`}
											</h5>
										</td>
									</tr>
								</table>
							</div>
						) : (
							''
						)}

						{valueMealAddOnData.fee && valueMealAddOnData.fee > 0 ? (
							<div style={{ margin: '20px 0 0 0' }}>
								<div
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
										margin: '20px 0 0',
									}}
								>
									<h4
										style={{
											padding: '0 20px',
											fontSize: '14px',
											fontWeight: 'bold',
											margin: '0',
										}}
									>
										Value Meals
									</h4>
									{valueMealAddOnData.canDelete !== false ? (
										<div
											className='remove-button'
											onClick={() => {
												setValueMealAddOn({
													item: '',
													fee: 0,
												});

												sessionStorageSetItem(
													'valueMealAddOn',
													JSON.stringify({}),
												);
											}}
										>
											<img src='./images/ic_delete_addon.png' />
										</div>
									) : (
										''
									)}
								</div>
								<table width={'100%'}>
									<tr>
										<td>
											<h6>
												{valueMealAddOnData.item}{' '}
												{valueMealAddOnData.isReturnTrip
													? ' (Depart and Return)'
													: ''}
											</h6>
										</td>
										<td>
											<h5>
												{valueMealAddOnData.fee === 0
													? 'Free'
													: `${(
														(valueMealAddOnData.isReturn
															? valueMealAddOnData.fee / 2
															: valueMealAddOnData.fee) /
														(currentCurrency === 'MYR'
															? 1
															: exchangeCurrency.addOnCurrency)
													).toFixed(2)} ${valueMealAddOnData.isReturn ? ' x2' : ''
													} ${noOfPax > 1 ? ` (${noOfPax} Passengers)` : ''}`}
											</h5>
										</td>
									</tr>
								</table>
							</div>
						) : (
							''
						)}
					</div>
				</div>
			</>
		);
	} else if (
		(checkReschedule == true &&
			origin_data.AddOnData != null &&
			origin_data.AddOnData.length != 0) ||
		insuranceAddOnData.plan !== 'No Insurance' ||
		healthCareAddOnData.fee > 0 ||
		valueMealAddOnData.fee > 0
	) {
		return (
			<>
				<div className='bus_fare_add_on'>
					<Row>
						<Col lg={12}>
							<div className='add-On-container'>
								<div className='text-in-line'>
									<h2>Add On</h2>
								</div>
								<div className='arrow-add-on'></div>
							</div>
						</Col>
					</Row>
					{checkReschedule == true &&
						origin_data.AddOnData != null &&
						origin_data.AddOnData.length != 0 &&
						origin_data.AddOnData.map(({ }, index) => (
							<div className='bus-fare-add-on'>
								<Row>
									<table className='mt-4 add-on-table'>
										{origin_data.AddOnData[index].map(
											(
												{
													details,
													imageurl,
													id,
													name,
													sessionid,
													totalamt,
													totalqty,
													traveldate,
												},
												index,
											) => (
												<>
													<tr>
														<td width={'70%'} colSpan={2}>
															<h4>{name}</h4>
														</td>
														<td></td>
														<td></td>
													</tr>
													{details.map(({ id, name, qty, subtotal }, index) => (
														<tr>
															<td width={'50%'}>
																<h6>{getAddOnTicketType(name)}</h6>
															</td>
															<td>
																<h6>x {qty}</h6>
															</td>
															<td>
																<h5>
																	{monetaryUnit} {subtotal != '' ? subtotal : 0}
																</h5>
															</td>
														</tr>
													))}
												</>
											),
										)}
									</table>
								</Row>
							</div>
						))}

					<div>
						{insuranceAddOnData.plan !== 'No Insurance' ? (
							<div style={{ margin: '20px 0 0 0' }}>
								<h4
									style={{
										padding: '0 20px',
										fontSize: '14px',
										margin: '10px 0 0',
										fontWeight: 'bold',
									}}
								>
									Travel Protection
								</h4>
								<table width={'100%'}>
									<tr>
										<td>
											<h6>{insuranceAddOnData.plan}</h6>
										</td>
										<td>
											<h5>
												{insuranceAddOn.fee === 0
													? 'Free'
													: (
														insuranceAddOnData.fee /
														(currentCurrency === 'MYR'
															? 1
															: exchangeCurrency.addOnCurrency)
													).toFixed(2)}
												{noOfPax > 1 ? ` (${noOfPax} Passengers)` : ''}
											</h5>
										</td>
									</tr>
								</table>
							</div>
						) : (
							''
						)}

						{healthCareAddOnData.fee && healthCareAddOnData.fee > 0 ? (
							<div style={{ margin: '20px 0 0 0' }}>
								<div
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
										margin: '20px 0 0',
									}}
								>
									<h4
										style={{
											padding: '0 20px',
											fontSize: '14px',
											fontWeight: 'bold',
											margin: '0',
										}}
									>
										Health Care
									</h4>
									{healthCareAddOnData.canDelete !== false ? (
										<div
											className='remove-button'
											onClick={() => {
												setHealthCareAddOn({
													item: '',
													fee: 0,
													isReturn: false,
												});

												sessionStorageSetItem(
													'healthCareAddOn',
													JSON.stringify({}),
												);
											}}
										>
											<img src='./images/ic_delete_addon.png' />
										</div>
									) : (
										''
									)}
								</div>
								<table width={'100%'}>
									<tr>
										<td>
											<h6>{healthCareAddOnData.item}</h6>
										</td>
										<td>
											<h5>
												{healthCareAddOnData.fee === 0
													? 'Free'
													: `${(
														(healthCareAddOnData.isReturn
															? healthCareAddOnData.fee / 2
															: healthCareAddOnData.fee) /
														(currentCurrency === 'MYR'
															? 1
															: exchangeCurrency.addOnCurrency)
													).toFixed(2)} ${healthCareAddOnData.isReturn ? ' x2' : ''
													} ${noOfPax > 1 ? ` (${noOfPax} Passengers)` : ''}`}
											</h5>
										</td>
									</tr>
								</table>
							</div>
						) : (
							''
						)}

						{valueMealAddOnData.fee && valueMealAddOnData.fee > 0 ? (
							<div style={{ margin: '20px 0 0 0' }}>
								<div
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
										margin: '20px 0 0',
									}}
								>
									<h4
										style={{
											padding: '0 20px',
											fontSize: '14px',
											fontWeight: 'bold',
											margin: '0',
										}}
									>
										Value Meals
									</h4>
									{valueMealAddOnData.canDelete !== false ? (
										<div
											className='remove-button'
											onClick={() => {
												setValueMealAddOn({
													item: '',
													fee: 0,
												});

												sessionStorageSetItem(
													'valueMealAddOn',
													JSON.stringify({}),
												);
											}}
										>
											<img src='./images/ic_delete_addon.png' />
										</div>
									) : (
										''
									)}
								</div>
								<table width={'100%'}>
									<tr>
										<td>
											<h6>{valueMealAddOnData.item}</h6>
										</td>
										<td>
											<h5>
												{valueMealAddOnData.fee === 0
													? 'Free'
													: `${(
														(valueMealAddOnData.isReturn
															? valueMealAddOnData.fee / 2
															: valueMealAddOnData.fee) /
														(currentCurrency === 'MYR'
															? 1
															: exchangeCurrency.addOnCurrency)
													).toFixed(2)} ${valueMealAddOnData.isReturn ? ' x2' : ''
													} ${noOfPax > 1 ? ` (${noOfPax} Passengers)` : ''
													}`}{' '}
												{valueMealAddOnData.isReturnTrip
													? ' (Depart and Return)'
													: ''}
											</h5>
										</td>
									</tr>
								</table>
							</div>
						) : (
							''
						)}
					</div>
				</div>
			</>
		);
	}
};
